/* globals alert */

define('modules/page_listing/views/create_page_popup',['require','exports','module','common/views/modal_view','../models/page','lib/util','common/models/appstate','backbone','underscore','ldsh!../templates/create_page'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view"),
      Page = require("../models/page"),
      util = require("lib/util"),
      AppState = require("common/models/appstate"),
      history = require("backbone").history,
      _ = require("underscore");

  var Controller = {
    getCollectionNames: function() {
      return this._collection.map(function(model) {
        return model.get('name');
      });
    },

    checkIfNameAlreadyExists: function(name) {
      return _.contains(this.getCollectionNames(), name);
    },

    doCreate: function(e) {
      e.preventDefault();

      var self = this,
        data = this._gatherData(),
        modelData;

      if (data.name.trim() === "") {
        this.$(".js-name-group").addClass("has-error");
        this.$(".js-name-required").removeClass("hidden");

        return;
      }

      this.$(".js-name-group").removeClass("has-error");
      this.$(".js-name-required").addClass("hidden");

      modelData = {
        'name': data.name,
        'redirect_to_amp': this.isPlatformAMP() ? 'all' : 'none'
      };

      this.model.set(modelData);
      this.model.source = data.source;
      this.blockControls();
      this.setName(data.name);

      if (this.checkIfNameAlreadyExists(data.name)) {
        self.showErrors(null, {status: 406});
        this.unblockControls();
        return;
      }

      if (data.source === "blank") {
        //save the page and start editing
        this.model.save({}, {
          patch: true,
          success: function(){
            self.unblockControls();
            self.redirectToEditor();
          },
          error: function(model, response) {
            self.unblockControls();
            self.showErrors(model, response);
          }
        });
      }
      else {
        //user has to select a template!
        AppState.saveItem("newPage", this.model);
        AppState.set("allPlatforms", !!data.devices);
        this.stopRedirection = true;
        this.unblockControls();
        this.redirectToTemplateList();
      }
    },

    doCancel: function(e){
      this.hide();
      this.remove();
    },

    remove: function() {
      if (!this.stopRedirection) {
        history.navigate("/pages", {replace: true});
      }
      module.exports.__super__.remove.apply(this, arguments);
    },

    redirectToEditor: function() {
      this.hide();
      history.navigate("/editor/" + this.model.get("id"), {trigger: true, replace: true});
    },

    redirectToTemplateList: function(){
      this.hide();
      history.navigate("/templates/" + this.model.platform, {trigger:true, replace: true});
    },

    showErrors: function(model, response) {
      if(response.status === 406){
        //name taken
        this.$(".js-name-group").addClass("has-error");
        this.$(".js-name-exists").removeClass("hidden");
      }
    },

    showTemplateCheck: function(e) {
      var source = this.$(".js-source:checked").val();
      this.$(".js-all-devices-wrapper").toggleClass("hidden", source === "blank");
    },

    _gatherData: function() {
      return {
        name: this.$(".js-name").val(),
        source: this.$(".js-source:checked").val(),
        devices: this.$(".js-devices:checked").val()
      };
    },

    setName: function(name) {
      this.$(".js-name").val(name);
    },

    isPlatformAMP: function () {
      return this._platform === 'amp';
    },

    blockControls: function() {
      this.$(".js-create").addClass("disabled");
      this.$(".js-cancel").addClass("disabled");
      this.$(".js-name").addClass("disabled");
    },

    unblockControls: function() {
      this.$(".js-create").removeClass("disabled");
      this.$(".js-cancel").removeClass("disabled");
      this.$(".js-name").removeClass("disabled");
    }
  };

  module.exports = ModalView.extend({
    initialize: function(options) {
      this.model = new Page();
      this._platform = this.model.platform = options.platform;
      this._collection = options.collection;
    },
    template: require("ldsh!../templates/create_page"),

    helpers: function() {
      return {
        isAMP: this.isPlatformAMP()
      };
    },

    events: {
      "click .js-create": "doCreate",
      "click .js-cancel": "doCancel",
      "click .js-source": "showTemplateCheck"
    },

    onRender: function() {
      this.$el.i18n();

      setTimeout(function() {
        this.$('#newPageName').focus();
      },  10);
    }
  });

  util.mixin(module.exports, Controller);

});

